module.exports = __webpack_public_path__ + "static/media/3.308694b3.svg";